"use strict";

PF.Field.FileList = class FileList extends PF.Field
	{
	static get options()
		{
		return {
			model: new PF.Model(),
			key: 'files',
			fileListConfig: {dom: {}, modelsConfig: {}},
			newItemData: {},
			errors: {}
		};
		}


	init()
		{
		this.fileListConfig.models = this.model.get(this.key, null, null);
		if (this.fileListConfig.models === null)
			{
			this.fileListConfig.models = new PF.Models({parent: this.model});
			this.model.setData(this.key, this.fileListConfig.models);
			}
		this.fileListConfig.dom.element = this.dom.element;

		this.fileList = new PF.FileList(this.fileListConfig);
		this.fileList.models.loadPart();
		}


	};
